var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDate28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.9993 3.00025L8.9988 5H19.9988L19.9993 3L20.9993 3.00025L20.9988 5H23.5C24.8807 5 26 6.11929 26 7.5V11V12V23.5C26 24.8807 24.8807 26 23.5 26H5.5C4.11929 26 3 24.8807 3 23.5V12V11V7.5C3 6.11929 4.11929 5 5.5 5H7.9988L7.9993 3L8.9993 3.00025ZM19.9985 6L19.998 8L20.998 8.00025L20.9985 6H23.5C24.3284 6 25 6.67157 25 7.5V11H4V7.5C4 6.67157 4.67157 6 5.5 6H7.99855L7.99805 8L8.99805 8.00025L8.99855 6H19.9985ZM25 12V23.5C25 24.3284 24.3284 25 23.5 25H5.5C4.67157 25 4 24.3284 4 23.5V12H25Z",
  fill: "currentColor"
})));
export default SvgDate28;